import { render, staticRenderFns } from "./BaseDeleteDialog.vue?vue&type=template&id=61efd7a2&"
import script from "./BaseDeleteDialog.vue?vue&type=script&lang=js&"
export * from "./BaseDeleteDialog.vue?vue&type=script&lang=js&"
import style0 from "./BaseDeleteDialog.vue?vue&type=style&index=0&id=61efd7a2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports